
import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import ValidateableMixin from '@/mixins/ValidateableMixin';

@Component({
    components: {},
    mixins: [ModelMixin, ValidateableMixin],
})
export default class LocateContinuesModal extends Mixins<ValidateableMixin, ModelMixin<boolean>>(
    ValidateableMixin,
    ModelMixin,
) {
    @Prop({ required: true })
    continues!: boolean;

    @Prop({ required: true })
    onContinue!: () => void;

    @Prop({ required: true })
    onCheckboxClick!: () => void;

    onClose() {
        this.model = false;
    }
}
